<template>
    <reg-bridge :isOpen="isOpen" :userData="args" @sendCode="sendCodeFn" @regDeal="regDealFn"></reg-bridge>
</template>

<script>
import { Message } from 'element-ui'
import regBridge from '../components/regBridge'
export default {
  name: 'bridge',
  components: {
    regBridge
  },
  props:['loginData'],
  data () {
    return {
      isOpen: false,
      args: {
        mobile: '',
        password: '',
        phoneCode: '',
        roleid: '',
      }
    }
  },
  watch: {
    loginData: function (data) {
      if (!data || !data.phone || !data.pwd) {
        this.isOpen = false
        return
      }
      this.args.mobile = data.phone
      this.args.password = data.pwd
      var _this = this
      miniSign('isPhoneExist', _this.args, function (existed) {
        if (existed) {
          miniSign('signIn', _this.args, function (signed) {
            _this.isOpen = false
          })
        } else {
          _this.isOpen = true
        }
      })
    }
  },
  methods: {
    signedIn () {
      var _this = this
      this.$message({
        message: '授权成功',
        type: 'success',
        onClose: function () {
          _this.isOpen = false
        }
      })
    },
    signFailed () {
      var _this = this
      this.$message({
        message: '授权失败',
        type: 'warn',
        onClose: function () {
          _this.isOpen = false
        }
      })
    },
    sendCodeFn () {
      var _this = this
      miniSign('sendPhoneCode', _this.args, function (sent) {
        if (!sent) {
          _this.$message({
            message: '验证码发送失败，请稍后重发！',
            type: 'warn'
          })
        }
      })
    },
    regDealFn (params) {
      this.args.phoneCode = params.code
      this.args.roleid = params.userType
      var _this = this
      miniSign( "signUp", _this.args, function (signed) {
        if (signed) {
          _this.signedIn()
        } else {
          _this.signFailed()
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
